module.exports = __webpack_public_path__ + "fca035a90399f89dea7deb1872f3e9ae.png";